var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensorOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Full",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Full .cls-1 {\n        fill: #c5d75d;\n        stroke: rgba(0,0,0,0);\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 -7.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2663",
    "data-name": "Pfad 2663",
    className: "cls-1",
    d: "M12,7.24A10.667,10.667,0,1,1,1.333,17.907,10.679,10.679,0,0,1,12,7.24m0-1.333a12,12,0,1,0,12,12,12,12,0,0,0-12-12",
    transform: "translate(0 1.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2664",
    "data-name": "Pfad 2664",
    className: "cls-1",
    d: "M14.692,12.326A8.594,8.594,0,0,0,8.041,15.46l.718.707a7.6,7.6,0,0,1,11.934.089l.718-.707a8.59,8.59,0,0,0-6.719-3.223",
    transform: "translate(-2.726 -0.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2665",
    "data-name": "Pfad 2665",
    className: "cls-1",
    d: "M16.009,18.192a4.55,4.55,0,0,0-3.782,2.024l.728.728a3.528,3.528,0,0,1,6.163.1l.732-.732a4.547,4.547,0,0,0-3.841-2.121",
    transform: "translate(-4.043 -2.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2666",
    "data-name": "Pfad 2666",
    className: "cls-1",
    d: "M15.3,15.259a6.478,6.478,0,0,0-5.166,2.578l.707.707a5.484,5.484,0,0,1,8.984.089l.707-.707A6.478,6.478,0,0,0,15.3,15.259",
    transform: "translate(-3.333 -1.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2667",
    "data-name": "Pfad 2667",
    className: "cls-1",
    d: "M19.282,27a2.644,2.644,0,1,1-5.288,0c0-1.477,2.644-5.257,2.644-5.257s2.644,3.78,2.644,5.257m-1.467-.87a.687.687,0,1,0,.679.687.683.683,0,0,0-.679-.687",
    transform: "translate(-4.642 -3.43)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorOk);
export default __webpack_public_path__ + "static/media/sensor-ok.8794c0780adaccbd6e5a3d68b5f78c70.svg";
export { ForwardRef as ReactComponent };